/**
 * Derive a sorted, deduplicated list of available tags from a leads array.
 * Uses case-insensitive deduplication (keeps the first casing encountered).
 *
 * @param {Array} leads - Array of lead objects (each may have a .tags array)
 * @returns {string[]} Sorted unique tags
 */
export const deriveAvailableTags = (leads) => {
  const tagMap = new Map();
  (leads || []).forEach(lead => {
    (lead.tags || []).forEach(tag => {
      const trimmed = tag.trim();
      if (trimmed && !tagMap.has(trimmed.toLowerCase())) {
        tagMap.set(trimmed.toLowerCase(), trimmed);
      }
    });
  });
  return [...tagMap.values()].sort((a, b) => a.localeCompare(b));
};
